import React from "react";
import styled from "styled-components";
import { getTheme } from "Theme";
const theme = getTheme();
const Background = styled.div`
  display: flex;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.7);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
`;

const Main = styled.div`
  display: flex;
  background-color: ${theme.PAGE_BACKGROUND};
  min-height: 200px;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 5%;
  width: ${(props) => props.width || "800px"};
  padding: 20px;
  border-radius: 10px;
  justify-content: center;
  z-index: 999;
  overflow: auto;
  /* tall content scrolls inside the modal instead of running off the screen
     (fixed position can't be scrolled to), e.g. the group permission list */
  max-height: 90vh;
  box-sizing: border-box;
`;

const Modal = ({ children, onClose, width  }: { children: React.ReactNode; onClose: () => void; width?: string }) => {
  return (
    <>
      <Background onClick={onClose} />
      <Main width={width}>{children}</Main>
    </>
  );
};

export default Modal;
